import { publicParams } from './../store/index'
import { mossoParams } from './../store/mosso'
import { getPttTcss } from './../request/mosso'

/**
 * mosso构造函数
 * @param {Object} args 实例化参数
 */
export default function Constructor(args) {
    let params = args;
    if (!params) params = {};

    // 合并params.mosso
    if (params.mosso) {
        params = Object.assign(params, params.mosso)
    }

    // 存起参数
    for (let attr in params) {
        if (publicParams[attr] !== undefined) {
            publicParams[attr] = params[attr]
        } else if(mossoParams.hasOwnProperty(attr)) {
            mossoParams[attr] = params[attr]
        }
    }

    // 加载tcss脚本
    getPttTcss()
}